"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M3.752 5.068l7.975 6.935a.657.657 0 00.828 0l7.806-6.935c.382-.351.127-.938-.424-.938L4.176 4.111c-.552 0-.806.606-.424.957zm18.603 12.736V7.94c0-.528-.679-.801-1.103-.43l-4.03 3.594a.445.445 0 00-.064.586l4.858 6.212c.106.137.34.059.34-.098zm-20.364 0V7.94c0-.528.679-.801 1.103-.43l4.052 3.594c.17.157.19.41.063.586l-4.878 6.212c-.106.137-.34.059-.34-.098zm18.584 2.071l-5.303-6.837a.492.492 0 00-.7-.059l-1.38 1.23c-.275.255-.657.372-1.017.392-.361 0-.743-.137-1.019-.391l-1.442-1.29a.403.403 0 00-.594.06l-5.346 6.895c-.17.215 0 .508.297.508h16.207c.297.02.466-.293.297-.508z" }), "SocialModeration");
//# sourceMappingURL=SocialModeration.js.map